export default __webpack_public_path__ + "static/media/verify.148aa9ae.svg";